import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const BE_URL = 'https://static.joinmytalent.com/jmt'
const PRO_BE_URL = 'https://static.joinmytalent.com/pro'

export const APP_NAMESPACE = 'translation'

/**
 * PRO certificates carry the tenant's translation namespace (e.g. 'Pauli') in
 * their render payload, and the renderer resolves the rating labels and texts
 * through it. Those live in the PRO tenant files, not in the app's own bundle —
 * so the namespace has to select the source. Without this every namespace
 * resolved to the app file and the certificate showed generic labels, or none
 * at all for goalkeepers.
 */
export const getLoadPath = (_lngs: string[], namespaces: string[]): string => {
    const namespace = namespaces[0]

    if (!namespace || namespace === APP_NAMESPACE) {
        return `${BE_URL}/{{lng}}.json`
    }

    return `${PRO_BE_URL}/${namespace}/{{lng}}.json`
}

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(HttpApi)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        load: 'languageOnly',
        ns: [APP_NAMESPACE],
        defaultNS: APP_NAMESPACE,
        // keys a tenant file does not define (e.g. the report page title) still
        // resolve against the app's own translations
        fallbackNS: APP_NAMESPACE,
        backend: {
            loadPath: getLoadPath,
        },
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        react: {
            useSuspense: false,
        },
        returnNull: false,
        returnEmptyString: false,
    })

export default i18n
